import styled, { css, keyframes } from "styled-components";
import { viewSizeCalculator } from "../../utils";
import { motion } from "framer-motion";

export const Wrapper = styled(motion.div)`
  width: ${() => `${viewSizeCalculator(23.5)}`}; // 19.75rem
  min-width: ${() => `${viewSizeCalculator(23.5)}`}; // 19.75rem
  height: ${() => `${viewSizeCalculator(4)}`}; // 3.75rem
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DropdownContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
  background-color: #f5f5f5;
  // box-shadow: 0 0.0625rem 0.3125rem #3333331a;
  // cursor: pointer;
`;

export const SelectedItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${() =>
    `${viewSizeCalculator(1.031)} ${viewSizeCalculator(
      1.563,
    )}`}; // 1.5rem 1.03rem
  padding: ${({ isSearchOpen }) =>
    !isSearchOpen
    ? `${viewSizeCalculator(1.031)} ${viewSizeCalculator(1.563)}`
    : `${viewSizeCalculator(0)} ${viewSizeCalculator(0)}`};
  height: 100%;
  font-size: ${() => `${viewSizeCalculator(1)}`}; // 1rem
  font-weight: 600;
  color: #333333;
  transition: all 0.3s ease-in-out;
  // div {
  //   display: flex;
  //   flex-direction: column;
  //   // max-width: 95%;
  //   overflow: hidden;
  //   white-space: nowrap;
  //   text-overflow: ellipsis;
  //   font-size: ${viewSizeCalculator(0.9)};
  // }

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: ${viewSizeCalculator(0.9)};
    // color: #898989;
  }

  img {
    width: ${() => `${viewSizeCalculator(2.5)}`}; // 1.5rem
    height: ${() => `${viewSizeCalculator(2.5)}`}; // 2.5rem
  }
`;

export const EllipsisContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 95%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: ${viewSizeCalculator(0.9)};
`; 

export const SelectedItemText = styled.div`
  display: flex;
  fontweight: 400;
  font-size: ${viewSizeCalculator(0.9)};
`;

export const DropdownButton = styled.button`
  border: none;
  outline: none;
  background-color: transparent;
  cursor: pointer;
  opacity: ${({ isHovered }) => (isHovered ? 1 : 0)};
  transition: all 0.3s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  svg {
    width: ${() => `${viewSizeCalculator(1.6)}`}; // 1.6rem;
    height: ${() => `${viewSizeCalculator(1.6)}`}; // 1rem;
  }
`;

export const Title = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.4)}`};

  &:hover {
    color: #e35b42;
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const PartnerLocationIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: visible !important;
  white-space: normal;

  svg {
    width: ${() => `${viewSizeCalculator(1)}`};
    height: ${() => `${viewSizeCalculator(1)}`};
    display: block;
    overflow: visible;
    flex-shrink: 0;
  }
`;

export const SubText = styled.div`
  font-size: ${() => `${viewSizeCalculator(0.75)}`};
  font-weight: 400;
  color: #000;
  opacity: 50%;
  // margin-top: ${() => `${viewSizeCalculator(0.25)}`};
  line-height: ${() => `${viewSizeCalculator(1.125)}`}; // 1.125rem
`;

export const HospitalSearchDropdown = styled.div`
  position: fixed;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
  width: ${(props) => props.width}px;
  z-index: 999;

  transform: scaleY(${(props) => (props.isOpen ? 1 : 0)});
  transform-origin: top;
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  visibility: ${(props) => (props.isOpen ? "visible" : "hidden")};

  transition:
    transform 0.3s ease,
    opacity 0.3s ease,
    visibility 0.3s ease ${(props) => (props.isOpen ? "0s" : "0.3s")};
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  // margin-right: ${() => `${viewSizeCalculator(0.5)}`};
  gap: ${() => `${viewSizeCalculator(0.5)}`};
`;

export const AddHospitalDiv = styled.div`
  width: 100%;
  height: 100%;
  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
  font-size: ${() => `${viewSizeCalculator(1)}`}; // 1.25rem
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${() => `${viewSizeCalculator(0.875)}`}; // 1.25rem
  background-color: #f5f5f5;
  cursor: pointer;
  // margin-left: ${({ isEmpty }) => !isEmpty ? `${viewSizeCalculator(0.875)}` : "0"};
  margin-right: ${({ isScrollActive }) => isScrollActive ? `${viewSizeCalculator(1)}` : "0"};
  svg {
    width: ${() => `${viewSizeCalculator(1.4)}`}; // 1.6rem;
    height: ${() => `${viewSizeCalculator(1.4)}`}; // 1rem;
  }
`;

const scaleIn = keyframes`
  from {
    transform: scale(1.2);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`;

export const AddHospitalText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${() => `${viewSizeCalculator(0.875)}`};
  transition: all 0.3s ease-in-out;
  ${({ animate }) =>
    animate &&
    css`
      animation: ${scaleIn} 0.3s ease-out;
    `}  
`;

export const SearchWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;

  transform: scale(${(props) => (props.isVisible ? 1 : 0.8)});
  // opacity: ${(props) => (props.isVisible ? 1 : 0)};
  // visibility: ${(props) => (props.isVisible ? "visible" : "hidden")};
  pointer-events: ${(props) => (props.isVisible ? "auto" : "none")};
  transition:
    transform 0.3s ease-in-out,
    opacity 0.3s ease-in-out,
    visibility 0.3s ease-in-out;
  transform-origin: center;
`;